import { render, staticRenderFns } from "./SurgeryAndTreatmentsList.vue?vue&type=template&id=7b7fb5f8"
import script from "./SurgeryAndTreatmentsList.vue?vue&type=script&lang=js"
export * from "./SurgeryAndTreatmentsList.vue?vue&type=script&lang=js"
import style0 from "./SurgeryAndTreatmentsList.vue?vue&type=style&index=0&id=7b7fb5f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports